import React, { useEffect, useMemo, useState } from "react";
import { isPattern } from "@formiz/validations";
import { toast } from "react-toastify";
import { useForm } from "@formiz/core";
import CommunEditModal from "../../../components/Modal/CommunEditModal";
import FormWizard from "../../../components/Form/FormWizard";
import TableComponent from "../../../components/Table/TableComponent";
import CommunModal from "../../../components/Modal/CommunModal";
import APICall, {explodeDataWithRowTable} from "../../../components/Api/APICall";
import { TableCellAmountFormate } from "./../../CommanApiFunction";

export default function ServiceManagement() {
  const [EditInputDefaultValue, setEditInputDefaultValue] = useState({
    ServiceName: "",
    ServicePrice: "",
  });
  const [ShowEditModal, setShowEditModal] = useState(false);
  const [Customer, setCustomer] = useState({
    row: [],
    dataWithRows: [],
    onlyData: [],
  });
  const [showModal, setShowModal] = useState(false);
  const col = [
    {
      accessor: "id",
      Header: "#",
      Cell: (cell) => {
        return (
          <i
            onClick={() => EditHandoler(cell.row.original)}
            title="Edit Customer"
            className="fa fa-edit cursor-pointer text-green-500 hover:text-orange-500 active:text-blue-500"
          ></i>
        );
      },
    },
    {
      accessor: "service_name",
      Header: "Service Name",
    },
    {
      accessor: "service_price",
      Header: "Service Price(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-orange-600"),
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const myForm = useForm();
  const editFormSubmit = (values) => {
    values.TableId = EditInputDefaultValue.tableId;
    setIsLoading(true);
    APICall("/service/Update", "POST", values)
      .then((data) => {
        if (data.status) {
          toast.success("Service Successfully Updated");
          CustomerAPiCall();
        } else {
          toast.error("Please try again");
        }
        setIsLoading(false);
        setShowEditModal(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Contact to developer Error : " + err);
      });
  };
  const submitForm = (values) => {
    // alert(JSON.stringify(values));
    setIsLoading(true);
    APICall("/service/add", "POST", values).then((response) => {
      if (response.status) {
        setIsLoading(false);
        myForm.reset();
        toast.success(response.message);
        CustomerAPiCall();
      } else {
        toast.error(response.message);
      }
    });
  };
  const CustomerAPiCall = () => {
    APICall("/service/getService").then((data) => {
      if (data.status) {
        if (data.message.length > 0) {
          const temp = data.message.map((v) => ({
            ...v,
          }));
          explodeDataWithRowTable(temp, setCustomer);
        }
      }
    });
  };

  const EditHandoler = (row) => {
    setEditInputDefaultValue({
      tableId: row.tableId,
      ServiceName: row.service_name,
      ServicePrice: row.service_price,
    });
    setShowEditModal(true);
  };
  const inptFildes = useMemo(
    () => [
      {
        title: "Add New Service",
        fileds: [
          {
            name: "ServiceName",
            label: "Service Name",
            required: "Service name is required",
            type: "text",
            defaultValue: EditInputDefaultValue.ServiceName,
          },
          {
            name: "ServicePrice",
            label: "Price",
            type: "text",
            defaultValue: EditInputDefaultValue.ServicePrice,
            validations: [
              {
                rule: isPattern("^[0-9]*$"),
                message: "only Number value allowed",
              },
            ],
          },
        ],
      },
    ],
    [EditInputDefaultValue]
  );
  useEffect(() => {
    CustomerAPiCall();
  }, []);
  return (
    <>
      <h3 className="text-center font-bold text-xl uppercase bg-blue-200 p-2 ">
        Service Management
      </h3>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <CommunEditModal
          showModal={ShowEditModal}
          setShowModal={setShowEditModal}
          Title="Update Service"
        >
          <FormWizard
            inputes={inptFildes}
            showStep={false}
            isLoading={isLoading}
            submitForm={editFormSubmit}
            myForm={myForm}
          />
        </CommunEditModal>
        <TableComponent
          columns={col}
          data={Customer.dataWithRows}
          pagination={true}
          exportData={true}
          TicketsTitle={`Service List`}
          other={
            <CommunModal
              showModal={showModal}
              setShowModal={setShowModal}
              btnName="Add Service"
              Title="Add New Service"
            >
              <FormWizard
                inputes={inptFildes}
                showStep={false}
                isLoading={isLoading}
                submitForm={submitForm}
                myForm={myForm}
              />
            </CommunModal>
          }
        />
      </div>
    </>
  );
}
